module.exports = __webpack_public_path__ + "img/lock_image.465dfb56.svg";